import { OnBoardingPage } from '@edwin-group/cj-graphql';
import OnBoardingContainer from '../../../components/on-boarding';
import { useOnBoardingV5 } from '../hooks/useOnBoardingV5';

export default function OnBoardingStep5() {
  const { page, currentStep, onClickOnBoardingCompleted } = useOnBoardingV5(5);

  return (
    <OnBoardingContainer
      page={page as OnBoardingPage}
      image={currentStep?.content?.image?.url || ''}
      step={4}
      title={currentStep?.content?.title || ''}
      description={currentStep?.content?.description || ''}
      button={{
        text: currentStep?.content?.button?.text || '',
        onClick: () => onClickOnBoardingCompleted(),
      }}
    />
  );
}
